<script>
import TooltipSelectorMixin from '~/components/decks/tooltip-selector/TooltipSelectorMixin'
import { reactionStates } from '~/common/reactions'

const { ON, OFF } = reactionStates

export default {
  name: 'ReactionSelector',
  mixins: [TooltipSelectorMixin],
  data () {
    return {
      options: [
        // disableSounds
        { id: ON, label: 'Sounds On', icon: 'volume-up' },
        { id: OFF, label: 'Sounds Off', icon: 'volume-mute' }
      ]
    }
  }
}
</script>
